
import { bestPicFormat } from '@/assets/scripts/utils'

export default {
  name: 'ApiEnumEtapes',
  props: {
    apiData: { type: Object, default: () => {} },
  },
  created() {
    this.bestPicFormat = bestPicFormat
  },
}
